module.exports = __webpack_public_path__ + "img/产品质量认证证书.0dcc4310.png";